import * as types from './constants';

// Create Assignment
export const createAssignmentRequest = data => (
  { type: types.CREATE_ASSIGNMENT_REQUEST, payload: data }
);

export const createAssignmentDone = data => (
  { type: types.CREATE_ASSIGNMENT_DONE, payload: data }
);

export const createAssignmentFailed = errors => (
  { type: types.CREATE_ASSIGNMENT_FAILED, payload: errors }
);

export const createAssignmentClearErrors = prop => (
  { type: types.CREATE_ASSIGNMENT_CLEAR_ERRORS, payload: prop }
);

export const createAssignmentReset = () => (
  { type: types.CREATE_ASSIGNMENT_RESET }
);